import { green } from '@material-ui/core/colors';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxHeight: '100%',
      flexGrow: 1,
    },
    toolbar: {
      marginLeft: theme.spacing(2),
      display: 'flex',
      flexDirection: 'row',
    },
    grow: {
      flexGrow: 1,
    },
    defaultBehaviorSwitch: {
      
    },
  })
);
